import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, toDisplayString as _toDisplayString, withCtx as _withCtx, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5a7be7f9"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"font-size":"16px","font-weight":"800","color":"var(--primary)","width":"100%"} }, " Fotos do Relatório ", -1))
const _hoisted_2 = { class: "ui-full" }
const _hoisted_3 = {
  class: "ant-row",
  style: {"margin-bottom":"20px"}
}
const _hoisted_4 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_5 = {
  role: "button",
  tabindex: "0",
  class: "ant-upload ant-upload-btn"
}
const _hoisted_6 = { class: "ant-upload-drag-container" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { class: "ant-upload-drag-icon" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "ant-upload-text" }, "Por favor, aguarde...", -1))
const _hoisted_10 = { key: 1 }
const _hoisted_11 = { class: "ui-nova-arquivo" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "ant-upload-text ui-nova-arquivo-descricao" }, "Formatos aceitos de Imagem: JPG, JPEG, PNG e WEBP.", -1))
const _hoisted_13 = {
  key: 0,
  class: "ant-row"
}
const _hoisted_14 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_15 = { class: "ui-arquivo" }
const _hoisted_16 = {
  key: 0,
  class: "ui-thumb"
}
const _hoisted_17 = { class: "ui-arquivo-info ui-full" }
const _hoisted_18 = { class: "ui-arquivo-nome" }
const _hoisted_19 = { class: "ui-arquivo-tamanho" }
const _hoisted_20 = { class: "ui-move ui-ordenar-arquivo" }
const _hoisted_21 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_spin = _resolveComponent("a-spin")!
  const _component_icone = _resolveComponent("icone")!
  const _component_a_image = _resolveComponent("a-image")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_draggable = _resolveComponent("draggable")!
  const _component_a_image_preview_group = _resolveComponent("a-image-preview-group")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_card = _resolveComponent("card")!
  const _component_a_collapse_panel = _resolveComponent("a-collapse-panel")!
  const _component_a_collapse = _resolveComponent("a-collapse")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_a_collapse, null, {
      default: _withCtx(() => [
        _createVNode(_component_a_collapse_panel, {
          key: "REL-FOTOGRAFICO",
          class: "ui-card-info-titulo-rope"
        }, {
          header: _withCtx(() => [
            _hoisted_1
          ]),
          default: _withCtx(() => [
            _createVNode(_component_card, { style: {"margin-bottom":"40px"} }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_2, [
                  _createVNode(_component_a_form, { layout: "vertical" }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_3, [
                        _createElementVNode("div", _hoisted_4, [
                          _createElementVNode("div", {
                            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.selecionarArquivoUpload && _ctx.selecionarArquivoUpload(...args))),
                            class: "ant-upload ant-upload-drag",
                            onDragenter: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["prevent"])),
                            onDragover: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["prevent"])),
                            onDrop: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.dropArquivo && _ctx.dropArquivo(...args)), ["prevent","stop"]))
                          }, [
                            _createElementVNode("span", _hoisted_5, [
                              _createElementVNode("input", {
                                id: "selecionarArquivo",
                                type: "file",
                                accept: ".png, .jpg, .jpeg, .webp",
                                multiple: "",
                                onChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.enviarArquivos($event))),
                                style: {"display":"none"}
                              }, null, 32),
                              _createElementVNode("div", _hoisted_6, [
                                ((_ctx.state.enviandoArquivos || _ctx.state.excluindoArquivos))
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                                      _createElementVNode("p", _hoisted_8, [
                                        _createVNode(_component_a_spin, { size: "large" })
                                      ]),
                                      _hoisted_9
                                    ]))
                                  : (_openBlock(), _createElementBlock("div", _hoisted_10, [
                                      _createElementVNode("span", _hoisted_11, [
                                        _createVNode(_component_icone, {
                                          style: {"font-size":"14px"},
                                          nome: "upload-nuvem"
                                        }),
                                        _createTextVNode(" Selecione ou arraste e solte seus arquivos aqui")
                                      ]),
                                      _hoisted_12
                                    ]))
                              ])
                            ])
                          ], 32)
                        ])
                      ]),
                      (_ctx.UtilitarioGeral.validaLista(_ctx.computedArquivos))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                            _createElementVNode("div", _hoisted_14, [
                              _createVNode(_component_a_image_preview_group, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_draggable, {
                                    modelValue: _ctx.computedArquivos,
                                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.computedArquivos) = $event)),
                                    "item-key": "arquivo",
                                    handle: ".ui-move",
                                    class: _normalizeClass(_ctx.computedArquivos.length > 9 ? 'ui-daj-center ui-arquivos' : 'ui-arquivos')
                                  }, {
                                    item: _withCtx(({ element }) => [
                                      _createElementVNode("div", _hoisted_15, [
                                        (_ctx.isImagem(element))
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                                              _createVNode(_component_a_image, {
                                                style: {"min-height":"100px"},
                                                width: 100,
                                                src: element.link,
                                                alt: element.nome
                                              }, null, 8, ["src", "alt"])
                                            ]))
                                          : _createCommentVNode("", true),
                                        _createElementVNode("div", _hoisted_17, [
                                          _createElementVNode("span", _hoisted_18, _toDisplayString(element.nome), 1),
                                          _createElementVNode("span", _hoisted_19, _toDisplayString(element.tamanho), 1),
                                          _createVNode(_component_a_input, {
                                            value: element.legenda,
                                            "onUpdate:value": ($event: any) => ((element.legenda) = $event),
                                            size: "small",
                                            class: "ui-arquivo-legenda ui-full",
                                            placeholder: "Legenda (opcional)",
                                            "max-length": 200
                                          }, null, 8, ["value", "onUpdate:value"]),
                                          _createVNode(_component_a_tooltip, {
                                            title: "Ordenar",
                                            placement: "bottom"
                                          }, {
                                            default: _withCtx(() => [
                                              _createElementVNode("a", _hoisted_20, [
                                                _createVNode(_component_icone, { nome: "draggable" })
                                              ])
                                            ]),
                                            _: 1
                                          }),
                                          _createVNode(_component_a_tooltip, {
                                            title: "Remover",
                                            color: "red",
                                            placement: "bottom"
                                          }, {
                                            default: _withCtx(() => [
                                              _createElementVNode("a", {
                                                title: "Remover",
                                                onClick: ($event: any) => (_ctx.confirmaExclusao(element)),
                                                class: "ui-remover-arquivo"
                                              }, [
                                                _createVNode(_component_icone, { nome: "excluir" })
                                              ], 8, _hoisted_21)
                                            ]),
                                            _: 2
                                          }, 1024)
                                        ])
                                      ])
                                    ]),
                                    _: 1
                                  }, 8, ["modelValue", "class"])
                                ]),
                                _: 1
                              })
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  })
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}